var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",style:(_vm.styleLoader),attrs:{"title":"Loading..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }